import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Badge, Button, Calendar, Card, ConfigProvider, Popconfirm, Radio, RadioChangeEvent, Table, Tag} from "antd";
import Historials from "../components/Historials";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import dayjs, {Dayjs} from 'dayjs';
import {format} from "date-fns";
import toast, {Toaster} from "react-hot-toast";
import { GetMenus } from '../../dao/menudesign/GetMenus';
import { Menu } from '../../model/menudesign/Menu';
import { MenuPlat } from '../../model/menudesign/MenuPlat';
import { Plat } from '../../model/menudesign/Plat';
import Ingredient from '../../model/menudesign/Ingredient';
import { GetPlats } from '../../dao/menudesign/GetPlats';
import { GetPlatsMenu } from '../../dao/menudesign/GetPlatsMenu';
import { GetIngredients } from '../../dao/menudesign/GetIngredients';
import MenuSetmanaModal from './components/MenuSetmanaModal';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekday from 'dayjs/plugin/weekday';
import caES from 'antd/locale/ca_ES';
import "dayjs/locale/ca";
import { ConfigProviderProps } from 'antd/lib';
import { Spin } from "antd"; 

const Menus = () => {
    const titol: string = "Menus";
    const nomPermis: string = "Menus";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    type Locale = ConfigProviderProps['locale'];
    dayjs.locale('ca');
    const [locale, setLocal] = useState<Locale>(caES);
    const [coleccio, setDades] = useState<Menu[]>([]);
    const [coleccioMP, setDadesMP] = useState<MenuPlat[]>([]);
    const [coleccioP, setDadesP] = useState<Plat[]>([]);
    const [coleccioI, setDadesI] = useState<Ingredient[]>([]);
    const [elementSelected, setElementSelected] = useState<Menu>(new Menu());
    const [loading, setLoading] = useState(false);
    const [editar, setEditar] = useState(false);
    
    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);

    const [filtres, setFiltres] = useState<RebutFIltre>(new RebutFIltre());
    const formatData = 'DD/MM/YYYY';
    const [value, setValue] = useState(() => dayjs(dayjs(), formatData));
    const [selectedValue, setSelectedValue] = useState(() => dayjs(dayjs(), formatData));
    const [modalOpen, setModalOpen] = useState(false);
    const [setmana, setSetmana] = useState('');
    const [dia, setDia] = useState<number>(1);
    const [diasetmana, setDiasetmana] = useState<number>(1);
    const [mes, setMes] = useState<number>(1);
    const [dataM, setdataM] = useState('');

    function disabledDate(current: dayjs.Dayjs) {
        const day = current.day();
        return day === 0 || day === 6;
    }
    const openMenuModal = (setmanaValue: string, diaValue: number, diasetmanaValue: number, dataMValue: string, month: number) => {
        setSetmana(setmanaValue);
        setDia(diaValue);
        setDiasetmana(diasetmanaValue);
        setdataM(dataMValue);
        setMes(month);
        setModalOpen(!modalOpen);
    };
    
    const onSelect = (newValue: Dayjs, info?: { source: 'year' | 'month' | 'date' | 'customize' }) => {
    setValue(newValue);
    setSelectedValue(newValue);

    // Solo abrir modal si el usuario hizo click en un día (source = "date")
    if (info?.source === "date") {
        const year = newValue.year();
        const numWeek = newValue.week();
        const stringSetmana = `${year}-W${numWeek}`;
        const dia = newValue.date();
        const diasetmana = newValue.weekday();
        const month = newValue.month();
        const dataM = dayjs(`${year}-${month + 1}-${dia}`).format('DD/MM/YYYY');

        openMenuModal(stringSetmana, dia, diasetmana, dataM, month);
    }
};


    const onPanelChange = (newValue: Dayjs) => {
        setValue(newValue);
    };
    
    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

    
    async function checkDades() {
        handleLoadingChange(true)
        const dades = await GetMenus(page) || [];
        const dadesMP = await GetPlatsMenu(page);
        const dadesP = await GetPlats(page) || [];
        const dadesI = await GetIngredients(page);
        setDades(dades);
        setDadesMP(dadesMP);
        setDadesP(dadesP);
        setDadesI(dadesI);
        //await setNameFilters(dades);
        await handleLoadingChange(false);
    }
    
    const cellRenderer = (value: Dayjs) =>{
        const menusBasales = coleccio.filter(menu => menu.basal == null);
        const idMenusBasal = menusBasales.map(menu => menu.id);
        const currentDate = value.format(formatData);
        const datesFiltrades = coleccioMP.filter(d => 
            idMenusBasal.includes(d.id_menu) &&
            format(d.data, 'dd/MM/yyyy') == currentDate
        )
        
        return (
        <ul style={{ listStyle: 'none', padding: 0 }}>
            {datesFiltrades.map((data) => {
                const plat = coleccioP.find(p => p.id === data.id_plat);
                const nom = plat?.nom.split('', 20).reduce((o, c) => o.length === 19 ? `${o}${c}...` : `${o}${c}`, '');
                return (
                    <li key={data.id}>
                        <Badge status="success" text={`${nom}`} />
                    </li>
                );
            })}
        </ul>
        );
        
    }


    function handleCloseModalSetmana() {
        setModalOpen(false);
        checkDades();
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };


    /**
     * FILTRES
     **/

    const handleNumberInput = (newIdRebut: number | null, attributeName: string) => {
        const idRebut = newIdRebut || 0;
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: idRebut,
        }));
    };

    const handleStringInput = (event: React.ChangeEvent<HTMLInputElement>, attributeName: string) => {
        const value = event.target.value || "";  // Usar una cadena vacía si el valor es nulo
        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: value,
        }));
    };


    const handleDateInput = (value: Dayjs | null, attributeName: string, format: string) => {
        const date = value && value.format(format) || "";

        setFiltres((prevRebutFiltre) => ({
            ...prevRebutFiltre,
            [attributeName]: date,
        }));
    };


    /**
     * --- FILTRES ----
     **/

    

    function modificarDatosForm() {
        //form.setFieldsValue({ remesa: 0 });
    }

    

    async function handleDownload (id: string)  {
        setLoading(true);
        //const documentUrl = await GetComandesGeneradesIdPdf(page, id);
        const documentUrl = ""; //TODO: delete

        if (documentUrl && documentUrl !== "") {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `facturaRemesa${id}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(true);
    };

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                
                <NavBar/>
                <Spin spinning={loading}>
                <div className={"general"}>
                    <Card bordered={true} className={"elemento"}>
                        <ConfigProvider locale={locale}>
                            <Calendar 
                            value={value} 
                            onSelect={onSelect} 
                            onPanelChange={onPanelChange} 
                            cellRender={cellRenderer} 
                            disabledDate={disabledDate}
                            />

                        </ConfigProvider>
                    </Card>
                    <br/>
                    <Historials pantalla={titol} pagina={page}/>
                    {modalOpen &&(
                        <MenuSetmanaModal element={elementSelected} onClose={handleCloseModalSetmana} visibleM={modalOpen} setmana={setmana} diames={dia} diasetmana={diasetmana} dataM={dataM} page={page}/>
                    )}
                </div>
                </Spin>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Menus;
